<template>
  <!-- <div class="row">
    <div class="col">
      <button class="btn btn-primary btn-sm" @click="isLoadingUser = true">show</button>
    </div>
  </div> -->
  <div v-if="isLoadingUser" class="custom-loading-user">
    <div class="loadingUserSpinner">
      <i class="fas fa-spinner fa-spin" aria-hidden="true"></i>
      <span>loading...</span>
    </div>
  </div>
  <!-- v-if="!isLoading && !isDialog" -->
  <user-header
    :show-title="showTitle"
    :firm="currentFirm"
    :pages="pages"
    :page-sizes="pageSizes"
    :num-items="count"
    :loading="isLoading"
    @search="search"
    @add="newUser"
    @delete="deleteUser"
    @activate="activateUser"
  />
  <!-- v-if="isLoading && !isDialog" -->
  <!-- <div  class="loadingWrapper">
    <div class="loadingSpinner">
      <i class="fas fa-spinner fa-spin" aria-hidden="true"></i>
      <span>loading...</span>
    </div>
  </div> -->
  <div class="table-responsive">
    <div class="custom-listing" :style="listingHeight">
      <z-table
        v-model="records"
        class="table table-bordered table-striped"
        :is-single-row-detail="false"
        :is-header-fixed="isHeaderFixed"
        :sort-by="sortBy"
        :order-by="orderBy"
        :columns="tableColumnsName"
        :detail-column-class="detailColumnClass"
        :loading="isLoading"
        @sort="setOrder"
      >
        <template #tbody="props">
          <td class="custom-column-60">
            <a href="#" @click="editUser(props.row)">view</a>
          </td>
          <th scope="row" class="custom-column-60">{{ props.row.user }}</th>
          <td>{{ props.row.username }}</td>
          <td>{{ props.row.fullName }}</td>
          <td>{{ props.row.firmName }}</td>
          <td>{{ props.row.roleName }}</td>
          <td>{{ props.row.employeeId }}</td>
          <td class="text-center">{{ showInactive(props.row.isinactive) }}</td>
        </template>
        <template #empty> Nothing found! </template>
      </z-table>
    </div>
  </div>
  <confirm-delete
    v-model="actionDelete"
    :confirm-title="confirmDeleteTitle"
    :confirm-action="confirmDeleteAction"
    :confirm-question="confirmDeleteQuestion"
    @closing="closeModal"
    @proceed="performDeletion"
  />
  <dialog-user
    v-model="actionUser"
    :show-firm="showFirm"
    @closing="closeModal"
    @saved="savedUser"
    @moved="movedUser"
    @changePassword="changePassword"
  />
  <dialog-password v-model="actionPassword" @closing="closeModalPassword" @save="performChangePassword" />
</template>
<script>
import { mapState, mapActions } from 'pinia'
import { authStore } from '@/stores/auth'
import { userStore } from '@/stores/user'
import { lookupStore } from '@/stores/lookup'
import { locationStore } from '@/stores/location'
import globals from '@/plugins/globals'
import ZTable from '@/components/utilities/elements/Table.vue'
import UserHeader from './UserHeader.vue'
import ConfirmDelete from '@/components/utilities/elements/ConfirmDialog.vue'
import DialogUser from './forms/DialogUser.vue'
import DialogPassword from './forms/DialogPassword.vue'

export default {
  name: 'UserListing',
  components: {
    ZTable,
    UserHeader,
    ConfirmDelete,
    DialogUser,
    DialogPassword
  },
  props: {
    firm: Object,
    showTitle: {
      type: Boolean,
      default: true
    },
    isHeaderFixed: {
      type: Boolean,
      default: false
    },
    listingHeight: String,
    showFirm: Object
  },
  data() {
    return {
      confirmDeleteTitle: 'Confirm User Deletion',
      confirmDeleteAction: 'Delete',
      confirmDeleteQuestion: 'Are you sure you wish to Permanently Delete checked users?',
      confirmActivateTitle: 'Confirm User Activation',
      confirmActivateAction: 'Activate',
      confirmActivateQuestion: 'Are you sure you wish to Activate checked users?',
      actionDelete: null,
      actionActivate: null,
      actionUser: null,
      actionPassword: null,
      page: 1,
      pageSizes: [
        { name: '10', value: 10 },
        { name: '25', value: 25 },
        { name: '50', value: 50 },
        { name: '100', value: 100 }
      ],
      detailColumnClass: 'custom-column-60',
      isLoadingUser: false,
      isAdd: false
    }
  },
  async mounted() {
    this.page = 1
    this.isLoadingUser = false
    this.isAdd = false
    this.setListParam({
      name: 'page',
      value: this.page
    })
    this.resetUser(this.currentFirm.firm)
    await this.getRoles(this.currentFirm.firm, this.isProvider)
    await this.search()
  },
  computed: {
    ...mapState(authStore, ['profile']),
    ...mapState(lookupStore, { lookupLoading: 'loading' }),
    ...mapState(userStore, ['loading', 'listParams', 'users', 'user']),
    count() {
      return this.users.count
    },
    records() {
      return this.users.items
    },
    tableColumnsName() {
      let columns = [
        {
          field: 'user',
          label: '',
          sortable: false,
          class: 'custom-column-60'
        },
        {
          field: 'user',
          label: 'Id',
          sortable: true,
          class: 'custom-column-80'
        },
        { field: 'username', label: 'Username', sortable: true },
        { field: 'fullName', label: 'Name', sortable: true },
        { field: 'firmName', label: 'Location (primary)', sortable: false },
        { field: 'roleName', label: 'Role', sortable: false },
        { field: 'employeeId', label: 'Employee #', sortable: false },
        { field: 'isinactive', label: 'Inactive?', sortable: false }
      ]
      return columns
    },
    pages() {
      return Math.ceil(this.users.count / this.listParams.pageSize)
    },
    sortBy() {
      return this.listParams.sortBy
    },
    orderBy() {
      return this.listParams.orderBy
    },
    isLoading() {
      let _is = false
      if (this.loading.users) {
        _is = true
      } else if (this.lookupLoading.userRoles) {
        _is = true
      }
      return _is
    },
    isDialog() {
      let _is = false
      if (this.actionUser !== null) {
        _is = true
      }
      if (this.actionPassword !== null) {
        _is = true
      }
      return _is
    },
    currentFirm() {
      let _firm = null
      if (this.firm == null) {
        console.log('Profile for Firm (in UserListing)', this.profile)
        _firm = {
          firm: this.profile.firm,
          firmName: this.profile.firmName
        }
        return _firm
      } else {
        console.log('Current Firm (in UserListing)', this.firm)
        return this.firm
      }
    },
    isFirm() {
      let _is = false
      if (this.showFirm) {
        _is = true
      }
      return _is
    },
    isProvider() {
      let _is = false
      // 2 = Provider Group
      // 3 = Service Provider
      if ([2, 3].includes(this.profile.connectClass)) {
        _is = true
      }
      return _is
    }
  },
  methods: {
    ...mapActions(lookupStore, ['getRoles', 'getLookups', 'getTechnicians']),
    ...mapActions(userStore, ['setListParam', 'paginate', 'getUser', 'getUsers', 'resetUser', 'deleteUsers', 'saveCredentials']),
    ...mapActions(locationStore, ['getInsurers']),
    formatDate(date, type = 'datetime') {
      return globals.formatDate(date, type)
    },
    closeModal() {
      this.actionUser = null
      this.actionDelete = null
    },
    closeModalPassword() {
      this.actionPassword = null
    },
    async setOrder(column, sortBy) {
      this.page = 1
      this.setListParam({
        name: 'sortBy',
        value: sortBy
      })
      this.setListParam({
        name: 'orderBy',
        value: column.field
      })
      await this.search(this.page, this.searchTerm)
    },
    showInactive(isInactive) {
      let _data = null
      if (isInactive) {
        _data = 'Y'
      }
      return _data
    },
    showFirmContact(id) {
      let _data = null
      if (parseInt(this.showFirm.user) === parseInt(id)) {
        _data = 'Y'
      }
      return _data
    },
    async search(page = 1) {
      // Load up the Users
      try {
        this.page = page
        await this.getUsers({
          page: this.page,
          offset: (this.page - 1) * this.listParams.pageSize,
          sortBy: this.listParams.sortBy,
          orderBy: this.listParams.orderBy,
          pageSize: this.listParams.pageSize,
          searchTerm: this.listParams.searchTerm,
          firm: this.firm !== undefined && this.firm !== null ? this.firm.firm : this.profile.firm
        })
      } catch (e) {
        console.log('Error', e)
      }
    },
    newUser() {
      this.resetUser(this.currentFirm.firm)
      this.isAdd = true
      this.actionUser = {
        isAdd: true,
        user: null,
        firm: this.firm.firm
      }
    },
    async editUser(data) {
      this.isAdd = false
      this.isLoadingUser = true
      await this.getUser(data.username)
      if (this.user) {
        if (this.user.firmClass === 1) {
          await this.getInsurers(this.profile.firm)
        }
        this.actionUser = {
          isAdd: false,
          user: this.user,
          firm: this.firm.firm
        }
      } else {
        this.actionUser = null
      }
      this.isLoadingUser = false
    },
    savedUser() {
      this.isAdd = false
      this.search()
    },
    movedUser() {
      this.actionUser = null
      this.search()
    },
    deleteUser() {
      this.actionDelete = true
    },
    activateUser() {},
    async performDeletion() {
      let users = []
      for (let user of this.users.items) {
        if (user.isChecked) {
          users.push({
            userId: user.user.toString(),
            token: null
          })
        }
      }
      this.actionDelete = null
      if (users.length > 0) {
        this.page = 1
        await this.deleteUsers(users)
        await this.search(this.page, this.searchTerm)
      }
    },
    async performChangePassword(data) {
      await this.saveCredentials(data)
      this.actionPassword = null
    },
    changePassword(data) {
      this.actionUser = null
      this.actionPassword = data
    }
  }
}
</script>
<style lang="scss">
.loadingWrapper {
  position: relative;
  top: 0;
  left: 0;
  width: 100%;
  height: auto;
  z-index: 10;
}
.loadingSpinner {
  margin-top: 40px;
  text-align: center;
  font-weight: 700;
  width: 100%;
  background: rgba(255, 255, 255, 0.6);
  padding: 10px;
  span {
    margin-left: 5px;
  }
}
.custom-listing {
  overflow-x: hidden;
  overflow-y: auto;
  width: 100%;
  max-height: 500px;
  height: 500px;
}
.custom-header {
  position: sticky;
  top: 0;
}
.custom-loading-user {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 10;
  background: rgba(0, 0, 0, 0.3);
  .loadingUserSpinner {
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    margin: auto;
    text-align: center;
    font-weight: 700;
    padding: 10px;
    z-index: 12;
    background-color: white;
    height: 45px;
    width: 150px;
    border-radius: 5px;
    span {
      margin-left: 5px;
      background-color: #fff;
    }
  }
}
</style>
